import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import Main from './Main';
import 'helpers/initFA';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { GoogleOAuthProvider } from '@react-oauth/google';

import { FacebookProvider } from 'react-facebook';
//import { FacebookProvider, Like } from 'react-facebook';

/* export default function LikeExample() {
  return (
    <FacebookProvider appId="123456789">
      <Like href="http://www.facebook.com" colorScheme="dark" showFaces share />
    </FacebookProvider>
  );
} */

const container = document.getElementById('main');
const root = createRoot(container);

const queryClient = new QueryClient();

root.render(
 <QueryClientProvider client={queryClient}>
  <GoogleOAuthProvider clientId="507835578448-tcsk19bgg5df3p45suqsq1q936vkqoa6.apps.googleusercontent.com">
   <FacebookProvider appId="607900580945566">
    <React.StrictMode>
     <Main>
      <App />
     </Main>
    </React.StrictMode>
   </FacebookProvider>
  </GoogleOAuthProvider>
  <ReactQueryDevtools initialIsOpen={false} />
 </QueryClientProvider>
);
